import Component from './component';
import iconClose from '../assets/icons/close.svg';
import iconSearch from '../assets/icons/search.svg';

/**
 * Provides a toggable search component for searching through items passed in as props
 */
export default class SearchComponent extends Component {
  constructor (props) {
    super(props);
    this.ontoggleclick = this.ontoggleclick.bind(this);
    this.onquerychange = this.onquerychange.bind(this);
    this.onitemselected = this.onitemselected.bind(this);
    this.onkeyup = this.onkeyup.bind(this);
    this.onblur = this.onblur.bind(this);
  }

  getDefaultProps () {
    return {
      opened: false,
      items: [],
      results: [],
      selectedIndex: -1,
      query: '',

      /**
       * Run a filter on the result by the current query
       *
       * @param  {object|string} result A result to be filtered
       * @param  {string}        query  A query to filter by
       * @return {boolean}
       */
      filter: function (result, query) {
        return result.indexOf(query) !== -1;
      },

      /**
       * Build the view for a matched result
       *
       * @param  {object|string} result A matched result
       * @return {string}
       */
      result: function (result) {
        return result;
      },

      /**
       * Handler executed when a search result is chosen
       *
       * @param  {object|string} result The chosen search result
       */
      onSelect: function (result) {}
    };
  }

  attach (element) {
    super.attach(element);

    this.$toggle = this.$('.iono-search-toggle');
    this.$input = this.$('.iono-search-input');
    this.$results = this.$('.iono-search-results');

    this.$toggle.addEventListener('click', this.ontoggleclick);
    this.$input.addEventListener('input', this.onquerychange);
    this.$results.addEventListener('click', this.onitemselected);
    this.$element.addEventListener('keyup', this.onkeyup);
    document.body.addEventListener('click', this.onblur);
  }

  update () {
    if (!this.$element) return;

    this.$element.dataset.state = this.props.opened ? 'open' : 'close';

    if (this.props.opened) {
      this.$input.focus();
    }

    this.$results.innerHTML = this.props.results.map((result, index) => {
      return `<div data-search-result-index="${index}" class="iono-search-result iono-theme-background-light@hover ${this.props.selectedIndex === index ? 'iono-selected' : ''}">${this.props.result(result, this.props.query)}</div>`;
    }).join('');
  }

  render () {
    return `
      <div class="iono-search iono-flex iono-flex-vertical" data-state="${this.props.opened ? 'open' : 'close'}">
        <div class="iono-search-box iono-flex">
          <input data-state-show="open" type="text" class="iono-search-input iono-input iono-flex-grow iono-theme-background" value="${this.props.query}" />
          <button class="iono-search-toggle iono-button iono-theme-button" title="Filter playlist items">
            <span class="iono-icon iono-icon-10 iono-button-icon" data-state-show="close" aria-hidden="true">${iconSearch}</span>
            <span class="iono-icon iono-icon-10 iono-button-icon" data-state-show="open" aria-hidden="true">${iconClose}</span>
          </button>
        </div>
        <div class="iono-search-results-container iono-theme-border">
          <div class="iono-search-results iono-theme-background iono-theme-border iono-theme-text"></div>
        </div>
      </div>
    `;
  }

  /**
   * Close the search component, hiding its results area
   */
  close () {
    if (!this.props.opened) return;
    this.setProps({
      // results: [],
      // selectedIndex: -1,
      opened: false
    });
  }

  /**
   * Open the search component, showing its results area
   */
  open () {
    if (this.props.opened) return;
    this.setProps({ opened: true });
  }

  /**
   * Open or close the search component
   */
  toggle () {
    if (this.props.opened) {
      this.close();
    } else {
      this.open();
    }
  }

  /**
   * Handles key presses, hiding the search area when ESC is pressed
   */
  onkeyup (event) {
    if (event.keyCode === 27) {
      this.close();
    }
  }

  /**
   * Handles input changes to the query input
   */
  onquerychange () {
    // trim whitespace from the start of the input value
    const query = this.$input.value.trimLeft();

    // ignore this event if the query has not changed
    if (this.props.query === query) return;

    // filter the search items to get a list of results matching the query
    const results = query !== '' ? this.props.items.filter(item => {
      return this.props.filter(item, query);
    }) : [];

    // update the component props
    this.setProps({ query, results });
  }

  /**
   * Handles clicks on the toggle button
   */
  ontoggleclick () {
    this.toggle();
  }

  /**
   * Selects the search result being clicked
   *
   * @param  {Event} event The click event
   */
  onitemselected (event) {
    const $item = event.target.closest('.iono-search-result');
    if ($item) {
      event.preventDefault();

      const index = parseInt($item.dataset.searchResultIndex, 10);
      const item = this.props.results[index];
      this.props.selectedIndex = index;
      this.props.onSelect(item);
      this.close();
      this.$toggle.focus();
    }
  }

  /**
   * Close the search component when the search input looses focus
   *
   * @param  {Event} event The blur event on the search input
   */
  onblur (event) {
    if (event.defaultPrevented) return;
    const search = event.target.closest('.iono-search');

    if (!search && this.props.opened) {
      this.close();
    }
  }
}
